import * as React from 'react';
import Input from '../../../../../Input';
import PhoneInput from '../../../../../PhoneInput';
import { Autocomplete } from '../../../../../index';
import { ThemeProvider, useTheme } from '../../../../../theme';
import { concatPassengerNames } from '../../../../../utils';
const EveryTravelInput = props => {
    var _a;
    const theme = useTheme('Checkout').EveryTravelInput;
    if (props.type === 'number') {
        const inputProps = props.TextFieldProps.InputProps;
        return (React.createElement(PhoneInput, { value: inputProps.value, textFieldsProps: {
                label: props.label,
                name: inputProps.name,
                onChange: inputProps.onChange,
                onBlur: inputProps.onBlur,
                error: props.TextFieldProps.error,
                helperText: props.TextFieldProps.helperText
            } }));
    }
    if (props.withAutocomplete && ((_a = props.travellers) === null || _a === void 0 ? void 0 : _a.length)) {
        const inputProps = props.TextFieldProps.InputProps;
        const themeAutocomplete = {
            Autocomplete: {
                Autocomplete: {
                    option: theme.autocomplete__option
                }
            }
        };
        return (React.createElement(ThemeProvider, { value: themeAutocomplete },
            React.createElement(Autocomplete, { name: inputProps.name, label: props.label, inputValue: inputProps.value, error: props.TextFieldProps.helperText, onInputChange: inputProps.onChange, onSelect: props.onAutocompleteSelect, options: props.travellers.map(traveller => ({
                    value: traveller.id,
                    label: concatPassengerNames({ lastName: traveller.lastname, firstName: traveller.firstname })
                })) })));
    }
    return React.createElement(Input, Object.assign({}, props));
};
export default EveryTravelInput;
